import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, HostListener, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
export interface Prefix {
  text: string;
}

@Component({
  selector: 'syn-document-breadcrumb',
  templateUrl: './document-breadcrumb.component.html',
  styleUrls: ['./document-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentBreadcrumbComponent implements OnInit {
  @Input() parentsArray: Observable<any>;
  @Input() prefix?: Prefix;
  @Output() crumbClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() prefixClicked: EventEmitter<any> = new EventEmitter<any>();
  public innerWidth = 100;

  ngOnInit() {
    //     this.innerWidth=0;
    //     this.innerWidth = window.innerWidth -200;




  }

  emitCrumbClicked(crumb) {
    this.crumbClicked.emit(crumb);

  }


  ngOnChanges(changes: SimpleChanges) {
    changes.parentsArray.currentValue.subscribe((res => {
      if (res.length >= 3) {
        for (let i = 1; i < res.length - 2; i++) {
          if (res[i].properties) {
            res[i].properties['cm:title'] = "...";
          }
          res[i].name = "...";
        }
      }
    }));
  }


  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth - 200;
  }
}
